import { z } from 'zod';
import { SimpleServerSchema } from './selected-server-options';

export const NewScriptSchema = z.object({
  name: z.string({ required_error: 'Script name is required' }).min(4, "Script name must be between 4 and 100 characters").max(100),
  slug: z.string({ required_error: 'Script slug is required' }).optional(),
  contents: z.string({ required_error: 'Script contents are required' }),
  description: z.string({ required_error: 'Description is required' }).optional(),
  tags: z.string({ required_error: 'Tags are required' }).optional(),
  showcase: z.string({ required_error: 'Showcase links are required' }).optional(),
  associated: z.string({ required_error: 'Associated scripts are required' }).optional(),
  fileType: z.string({ required_error: 'File type is required' }).optional(),
  //z.optional(z.string()),
  skills: z.string({ required_error: 'Skills are required' }).optional(),
  category: z.string({ required_error: 'Category is required' }).optional(),
  hotkeyCtrl: z.optional(z.boolean()),
  hotkeyShift: z.optional(z.boolean()),
  hotkeyAlt: z.optional(z.boolean()),
  hotkey: z.string().max(1).optional(),
  server: SimpleServerSchema,
})

export const sanitizeSlug = (content: string | undefined | null, user: string | undefined | null) => {
    if (!content) return ''
    if (user !== null && user !== undefined) {
        content =  content + "-" + user.substring(0, 8)
    } else {
        content = content + "anon-"
    }
    return content.toLowerCase().replace(/[^a-z0-9]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
}

export const EditBuildSchema = z.object({
    name: z.string({ required_error: 'Build name is required' }).min(4, "Build name must be between 4 and 100 characters").max(100),
    description: z.string({ required_error: 'Description is required' }).optional(),
    gear: z.string({ required_error: 'Gear is required' }).optional(),
    tags: z.array(z.string({ required_error: 'One tag is required' })),
    difficulty: z.string({ required_error: 'Difficulty is required' }).optional(),
  })

export const NewBuildSchema = z.object({
    name: z.string({ required_error: 'Build name is required' }).min(4, "Build name must be between 4 and 100 characters").max(100),
    description: z.string({ required_error: 'Description is required' }).optional(),
    gear: z.string({ required_error: 'Gear is required' }).optional(),
    build: z.string({ required_error: 'Skills are required' }),
    tags: z.array(z.string({ required_error: 'One tag is required' })),
    character: z.string({ required_error: 'Character link is optional' }).optional(),
    difficulty: z.string({ required_error: 'Difficulty is required' }).optional(),
    slug: z.string({ required_error: 'Build name is required' }).optional(),
  })

export const cleanSkillName = (razorName: string) => {


    switch (razorName.toLowerCase()) {
        case "alch":
        case "alchemy":
            return "Alchemy";
        case "anatomy":
            return "Anatomy"
        case "animal lore":
        case "animallore":
            return "Animal Lore"
        case "itemid":
            return "Item Identification"
        case "armslore":
            return "Arms Lore"
        case "parry":
        case "parrying":
            return "Parry"
        case "begging":
            return "Begging"
        case "blacksmith":
        case "blacksmithing":
            return "Blacksmithing"
        case "arcane":
            return "Arcane"
        case "peacemaking":
            return "Peacemaking"
        case "camping":
            return "Camping"
        case "carpentry":
            return "Carpentry"
        case "cartography":
            return "Cartography"
        case "cooking":
            return "Cooking"
        case "detecthidden":
            return "Detect Hidden"
        case "discordance":
            return "Discordance"
        case "evaluate intelligence":
        case "eval intelligence":
        case "evalint":
            return "Eval Intelligence"
        case "healing":
            return "Healing"
        case "fishing":
            return "Fishing"
        case "forensics":
            return "Forensics"
        case "herding":
            return "Herding"
        case "hiding":
            return "Hiding"
        case "provocation":
            return "Provocation"
        case "inscription":
        case "inscribe":
            return "Inscription"
        case "lock picking":
        case "lockpicking":
            return "Lockpicking"
        case "magery":
            return "Magery"
        case "magicresist":
        case "magic resist":
            return "Magic Resist"
        case "tactics":
            return "Tactics"
        case "snooping":
            return "Snooping"
        case "musicianship":
            return "Musicianship"
        case "poisoning":
            return "Poisoning"
        case "archery":
            return "Archery"
        case "spiritspeak":
        case "spirit speak":
            return "Spirit Speak"
        case "stealing":
            return "Stealing"
        case "tailoring":
            return "Tailoring"
        case "animaltaming":
            return "Animal Taming"
        case "tasteid":
            return "Taste ID"
        case "tinkering":
            return "Tinkering"
        case "tracking":
            return "Tracking"
        case "veterinary":
            return "Veterinary"
        case "swords":
            return "Swords"
        case "macing":
            return "Macing"
        case "fencing":
            return "Fencing"
        case "wrestling":
            return "Wrestling"
        case "lumberjacking":
            return "Lumberjacking"
        case "mining":
            return "Mining"
        case "meditation":
            return "Meditation"
        case "stealth":
            return "Stealth"
        case "removetrap":
            return "RemoveTrap"
        case "necromancy":
            return "Necromancy"
        case "focus":
            return "Focus"
        case "chivalry":
            return "Chivalry"
        case "bushido":
            return "Bushido"
        case "ninjitsu":
            return "Ninjitsu"
        case "spellweaving":
            return "SpellWeaving"
        case "mysticism":
            return "Mysticism"
        case "imbuing":
            return "Imbuing"
        case "throwing":
            return "Throwing"
        case "ItemID":
            return "Item Identification";
        case "Carpentry":
            return "Carpentry/Bowcraft";
        case "ArmsLore":
            return "Arms Lore";
        case "Blacksmith":
            return "Blacksmithy";
        case "DetectHidden":
            return "Detecting Hidden";
        case "EvalInt":
            return "Evaluating Intelligence";
        case "Forensics":
            return "Forensic Evaluation";
        case "Inscribe":
            return "Inscription";
        case "MagicResist":
            return "Resisting Spells";
        case "SpiritSpeak":
            return "Spirit Speaking";
        case "AnimalTaming":
            return "Animal Taming";
        case "TasteID":
            return "Taste Identification";
        case "Swords":
            return "Swordsmanship";
        case "Macing":
            return "Mace Fighting";
        case "RemoveTrap":
            return "Remove Trap";
        default:
            return razorName;
    }
}

/**
 * Inverse of `cleanSkillName`: display label -> the Razor-form token used inside
 * a stored `UserBuildTemplate.build` string.
 *
 * Lived inline in `builds+/$serverSlug.new.tsx` until the Script Builder needed
 * to write build strings too. Both paths MUST agree here — `buildSignature` is a
 * hash of the serialized string, and it's what groups the same build across
 * players (player counts, perspectives, adoption).
 */
export const toRazorSkillName = (cleanName: string) => {
    switch (cleanName) {
        case "Animal Lore":
            return "AnimalLore";
        case "Item Identification":
            return "ItemID";
        case "Carpentry/Bowcraft":
            return "Carpentry";
        case "Arms Lore":
            return "ArmsLore";
        case "Blacksmithy":
            return "Blacksmith";
        case "Detecting Hidden":
            return "DetectHidden";
        case "Evaluating Intelligence":
            return "EvalInt";
        case "Forensic Evaluation":
            return "Forensics";
        case "Inscription":
            return "Inscribe";
        case "Resisting Spells":
            return "MagicResist";
        case "Spirit Speaking":
            return "SpiritSpeak";
        case "Animal Taming":
            return "AnimalTaming";
        case "Taste Identification":
            return "TasteID";
        case "Swordsmanship":
            return "Swords";
        case "Mace Fighting":
            return "Macing";
        case "Remove Trap":
            return "RemoveTrap";
        default:
            return cleanName;
    }
}

/**
 * Serialize skills into the canonical `UserBuildTemplate.build` string:
 * `"skill|value,..."`, Razor-form names, lowercased. Skill ORDER is significant
 * — it feeds `generateBuildSignature` — so callers must not sort.
 */
export const serializeBuildString = (
    skills: { name: string; value: number }[],
) => skills.map(x => `${toRazorSkillName(x.name).toLowerCase()}|${x.value}`).join(",")

export const buildRatingMeter = (difficulty: string | number | undefined) => {
    if (typeof difficulty === "undefined") return ""
    
    difficulty = Number(difficulty)

    if (difficulty >= 10)
        return "Hardcore"

    if (difficulty >= 9)
        return "Extremely Hard"

    if (difficulty >= 8)
        return "Very Hard"

    if (difficulty >= 7)
        return "Pretty Hard"

    if (difficulty >= 6)
        return "Hard"

    if (difficulty >= 5)
        return "Medium"
    
    if (difficulty >= 4)
        return "Easy"

    if (difficulty >= 3)
        return "Pretty Easy"

    if (difficulty >= 2)
        return "Very Easy"

    if (difficulty >= 1)
        return "Extremely Easy"

    if (difficulty >= 0)
        return "Newbie"

}